import {
  Activity,
  BookOpen,
  Boxes,
  ClipboardCheck,
  Download,
  Gift,
  GitCompare,
  GraduationCap,
  Layers,
  Library,
  ListChecks,
  PenTool,
  Presentation,
  Ruler,
  Scissors,
  ShieldCheck,
  Shirt,
  Sparkles,
  Star,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Sewing Fundamentals & Machine Skills', icon: BookOpen },
  { label: 'Fabrics & Fibers', icon: Layers },
  { label: 'Body Measurements', icon: Ruler },
  { label: 'Pattern Drafting', icon: PenTool },
  { label: 'Draping & Fitting', icon: Shirt },
  { label: 'Cutting & Layout', icon: Scissors },
  { label: 'Garment Construction', icon: Wrench },
  { label: 'Tailoring & Finishing', icon: Sparkles },
  { label: 'Alterations & Repairs', icon: Activity },
  { label: 'Studio Safety', icon: ShieldCheck },
  { label: 'Course Programs', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Competency Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: Sparkles },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Immediate Digital Access', icon: Download },
]
